<!-- Verification View -->
<div id="step-verification" class="step-view p-8 space-y-6">
  <div class="text-center space-y-2">
    <h2 class="text-2xl font-semibold text-gray-900">
      Enter authentication code<br />from your email
    </h2>
    <p id="verification-hint" class="text-gray-600">
      A code was sent to <span>{{currentEmail}}</span>
    </p>
  </div>

  <div class="space-y-6">
    <div id="verification-inputs" class="flex justify-between gap-2">
      <code-input [isCodeHidden]="false"
                  [codeLength]="6"
                  (codeCompleted)="onCodeCompleted($event)">
      </code-input>
    </div>
    <p *ngIf="errorMsg" id="verification-error" class="text-sm text-red-500 text-center">{{errorMsg}}</p>
  </div>

  <div class="text-center space-y-4">
    <div class="text-sm text-gray-600">
      Code expires in
      <span id="verification-countdown" class="font-semibold text-gray-900">{{timeRemaining$ | async | date:'mm:ss'}}</span>
    </div>
    <div class="space-x-2">
      <button
        id="resend-code"
        class="text-[#5B47FB] hover:text-[#4936E8] text-sm font-medium disabled:cursor-not-allowed disabled:opacity-60"
        [disabled]="loading || resendingCode"
        (click)="onResendCode()">
        {{ resendingCode ? 'Resending...' : 'Resend code' }}
      </button>
      <span class="text-gray-300"  style="display:none;">|</span>
      <button id="use-other-method" class="text-[#5B47FB] hover:text-[#4936E8] text-sm font-medium"             style="display:none;">
        Use another method
      </button>
    </div>
  </div>
</div>
